import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IUser } from '../../../shared/interfaces/IUser';
import { RootState } from '../../../store/store';

interface IProps {
  isUpdate?: boolean;
  register: UseFormRegister<IUser>;
  errors: FieldErrors<IUser>;
}
const UserForm = ({ register, errors, isUpdate }: IProps) => {
  const { t } = useTranslation();
  const { country, language } = useSelector((state: RootState) => state.enums);
  return (
    <Row>
      <Col md={6}>
        <Form.Group className="mb-3" controlId="form.firstName">
          <Form.Label>{t('general.firstName')}</Form.Label>
          <Form.Control
            type="text"
            placeholder={t('general.firstName')}
            isInvalid={!!errors.firstName}
            {...register('firstName')}
          />
          {errors?.firstName && (
            <Form.Control.Feedback type="invalid">
              {errors.firstName.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group className="mb-3" controlId="form.lastName">
          <Form.Label>{t('general.lastName')}</Form.Label>
          <Form.Control
            type="text"
            placeholder={t('general.lastName')}
            isInvalid={!!errors.lastName}
            {...register('lastName')}
          />
          {errors?.lastName && (
            <Form.Control.Feedback type="invalid">
              {errors.lastName.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group className="mb-3" controlId="form.email">
          <Form.Label>{t('general.email')}</Form.Label>
          <Form.Control
            type="email"
            placeholder={t('general.email')}
            isInvalid={!!errors.email}
            {...register('email')}
          />
          {errors?.email && (
            <Form.Control.Feedback type="invalid">
              {errors.email.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group className="mb-3" controlId="form.phoneNumber">
          <Form.Label>{t('general.phoneNumber')}</Form.Label>
          <Form.Control
            type="tel"
            placeholder={t('general.phoneNumber')}
            isInvalid={!!errors.phoneNumber}
            {...register('phoneNumber')}
          />
          {errors?.phoneNumber && (
            <Form.Control.Feedback type="invalid">
              {errors.phoneNumber.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group className="mb-3" controlId="form.birthday">
          <Form.Label>{t('general.birthday')}</Form.Label>
          <Form.Control
            type="date"
            placeholder={t('general.birthday')}
            isInvalid={!!errors.birthday}
            {...register('birthday')}
          />
          {errors?.birthday && (
            <Form.Control.Feedback type="invalid">
              {errors.birthday.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group className="mb-3" controlId="form.address">
          <Form.Label>{t('general.address')}</Form.Label>
          <Form.Control
            type="text"
            placeholder={t('general.address')}
            isInvalid={!!errors.address}
            {...register('address')}
          />
          {errors?.address && (
            <Form.Control.Feedback type="invalid">
              {errors.address.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>
      {!isUpdate && (
        <Col md={6}>
          <Form.Group className="mb-3" controlId="form.password">
            <Form.Label>{t('general.password')}</Form.Label>
            <Form.Control
              type="password"
              placeholder={t('general.password')}
              isInvalid={!!errors.password}
              {...register('password')}
            />
            {errors?.password && (
              <Form.Control.Feedback type="invalid">
                {errors.password.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Col>
      )}

      <Col md={6}>
        <Form.Group className="mb-3" controlId="form.city">
          <Form.Label>{t('general.city')}</Form.Label>
          <Form.Control
            type="text"
            placeholder={t('general.city')}
            isInvalid={!!errors.city}
            {...register('city')}
          />
          {errors?.city && (
            <Form.Control.Feedback type="invalid">
              {errors.city.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>

      <Col md={isUpdate ? 6 : 4}>
        <Form.Group className="mb-3" controlId="form.zipCode">
          <Form.Label>{t('general.zipCode')}</Form.Label>
          <Form.Control
            type="text"
            placeholder={t('general.zipCode')}
            isInvalid={!!errors.zipCode}
            {...register('zipCode')}
          />
          {errors?.zipCode && (
            <Form.Control.Feedback type="invalid">
              {errors.zipCode.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>

      <Col md={isUpdate ? 6 : 4}>
        <Form.Group className="mb-3" controlId="form.country">
          <Form.Label>{t('general.country')}</Form.Label>
          <Form.Select isInvalid={!!errors.country} {...register('country')}>
            {country?.map((country) => {
              return (
                <option value={country} key={country}>
                  {t(`country.${country}` as string)}
                </option>
              );
            })}
          </Form.Select>

          {errors?.country && (
            <Form.Control.Feedback type="invalid">
              {errors.country.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>

      <Col md={isUpdate ? 6 : 4}>
        <Form.Group className="mb-3" controlId="form.language">
          <Form.Label>{t('general.language')}</Form.Label>
          <Form.Select isInvalid={!!errors.language} {...register('language')}>
            {language?.map((language) => {
              return (
                <option value={language} key={language}>
                  {t(`language.${language}` as string)}
                </option>
              );
            })}
          </Form.Select>

          {errors?.language && (
            <Form.Control.Feedback type="invalid">
              {errors.language.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>
    </Row>
  );
};

export default UserForm;
